import RincianMitraGudang from './RincianMitraGudang.vue'

export default RincianMitraGudang
